import * as GlobalS from "@/components/styled";
import { useProjectContext } from "@/providers";
import { Button, Col, Row, Space, Switch, Tooltip } from "antd";
import { useIntl } from "react-intl";

import {
  MilestoneList,
  ScheduleDropdownActionsButton,
  SchedulesCard,
  ScheduleSelector,
} from "@/containers/Project/components";
import { ProjectUserPermissions } from "@/enums";
import { useGetProjectTemplateQuery } from "@/services";

const MilestoneCard = () => {
  const intl = useIntl();
  const {
    canUser,
    milestoneListCollapsed,
    setMilestoneListCollapsed,
    milestoneListChildren,
    toggleTopOnly,
    project,
  } = useProjectContext();

  const { data: projectTemplate } = useGetProjectTemplateQuery(
    project?.projectTemplateId,
    {
      skip: !project?.projectTemplateId,
    }
  );

  return (
    <>
      <Row className="pb-2">
        <Col flex={1}>
          <SchedulesCard />
        </Col>
      </Row>
      <GlobalS.GrayCard
        size="small"
        title={intl.formatMessage({
          id: "project.milestonesTitle",
        })}
        extra={
          <Row gutter={[16, 48]}>
            <Col className="m-auto" flex={1}>
              <Space>
                <Tooltip
                  title={intl.formatMessage({
                    id: "milestonesList.topTooltip",
                  })}
                >
                  <Switch
                    checked={!milestoneListChildren.topOnly}
                    onChange={toggleTopOnly}
                    data-test-id={"toggle-milestones-list-top"}
                    checkedChildren={intl.formatMessage({
                      id: "milestonesList.all",
                    })}
                    unCheckedChildren={intl.formatMessage({
                      id: "milestonesList.top",
                    })}
                  />
                </Tooltip>
                <Tooltip
                  title={intl.formatMessage({
                    id: "milestonesList.expandTooltip",
                  })}
                >
                  <Switch
                    checked={!milestoneListCollapsed}
                    onChange={setMilestoneListCollapsed}
                    data-test-id={"toggle-milestones-list"}
                    checkedChildren={intl.formatMessage({
                      id: "milestonesList.expand",
                    })}
                    unCheckedChildren={intl.formatMessage({
                      id: "milestonesList.collapse",
                    })}
                  />
                </Tooltip>
              </Space>
            </Col>
            <Col flex={1}>
              <ScheduleSelector />
            </Col>
            <Col flex={1}>
              {canUser(ProjectUserPermissions.ViewScheduleDropdown) ? (
                <ScheduleDropdownActionsButton data-test-id="schedule-dropdown-options" />
              ) : (
                <>
                  {projectTemplate?.vigorTemplateUrl?.length && (
                    <Button
                      data-test-id={`vigor-templates-button`}
                      key={`vigor-templates-button`}
                      onClick={() =>
                        window.open(projectTemplate.vigorTemplateUrl)
                      }
                    >
                      {intl.formatMessage({
                        id: "project.vigorTemplatesLabel",
                      })}
                    </Button>
                  )}
                </>
              )}
            </Col>
          </Row>
        }
      >
        <MilestoneList />
      </GlobalS.GrayCard>
    </>
  );
};

export { MilestoneCard };
